import React, { useRef, useEffect } from 'react';
import { TweenMax, Power3, Power0 } from 'gsap';
import '../styles/Experience.scss';

const Experience = () => {
    let sectionRef = useRef(null);
    let contentRef = useRef(null);
    let shapeRef = useRef(null);

    useEffect(() => {
        // Floating animation
        TweenMax.to(shapeRef, 20, {
            rotation: 360,
            ease: Power0.easeNone,
            repeat: -1
        });

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        TweenMax.to(contentRef, 1, {
                            opacity: 1,
                            x: 0,
                            ease: Power3.easeOut
                        });
                        TweenMax.to(shapeRef, 1, {
                            opacity: 1,
                            scale: 1,
                            ease: Power3.easeOut,
                            delay: 0.3
                        });
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.3 }
        );

        observer.observe(sectionRef);

        // Initial State
        TweenMax.set(contentRef, { opacity: 0, x: -50 });
        TweenMax.set(shapeRef, { opacity: 0, scale: 0.5 });

        return () => observer.disconnect();
    }, []);

    return (
        <section id="experience" className="experience" ref={el => sectionRef = el}>
            <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div className="experience-content" ref={el => contentRef = el}>
                    <h2>Zero Gravity.<br />Zero Compromise.</h2>
                    <p>
                        Our fleet is equipped with state-of-the-art artificial gravity zones, allowing you to dine and sleep in comfort,
                        while our observation decks offer true weightlessness for the ultimate view.
                    </p>
                    <ul className="features">
                        <li>5-Star Dining</li>
                        <li>Hypersleep Suites</li>
                        <li>Orbital Spa</li>
                    </ul>

                    <div className="timeline">
                        <h3>A Day Onboard</h3>
                        <div className="timeline-item">
                            <span className="time">08:00</span>
                            <p>Sunrise Yoga in the Observation Dome</p>
                        </div>
                        <div className="timeline-item">
                            <span className="time">13:00</span>
                            <p>Zero-G Hydroponic Lunch</p>
                        </div>
                        <div className="timeline-item">
                            <span className="time">20:00</span>
                            <p>Cocktails at the Edge of Infinity</p>
                        </div>
                    </div>
                </div>
                <div className="experience-visual">
                    {/* Abstract geometric shape as placeholder for visual */}
                    <div className="geometric-shape" ref={el => shapeRef = el}></div>
                </div>
            </div>
        </section>
    );
};

export default Experience;
